import { useMemo } from "react"
import { FieldType, FieldValue, FormField, option } from "../../../../../features/ui"
import { TableName } from "../../../../../tables"
import { useDataTypesHooks } from "../../../../../features/data-types"
import { useDriverLoaders } from "../../../loaders/driverLoaders"

type Props = {
    defaultValue?: string
    value?: string
    disabled?: boolean
    onChange?: (value?: FieldValue) => void
}

export const DriverField = (props: Props): FormField => {
    const { defaultValue, value, disabled, onChange } = props

    const { formatIdentifier } = useDataTypesHooks()

    const driverLoaders = useDriverLoaders()

    const options = useMemo(() => {
        const allDrivers = driverLoaders().findAllDrivers(true)
        return allDrivers.map(driver => option(driver.id, `${driver.name} (${formatIdentifier(driver.identifier)})`))
    }, [])

    return {
        name: 'driverId',
        type: FieldType.TABLE,
        table: TableName.DRIVERS,
        label: 'Conductor',
        defaultValue,
        value,
        options,
        disabled,
        onChange
    }
}
